import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { AppRouting } from './Components/LayoutArea/Routing/AppRouting';
import { store } from './Redux/store';
import { signedOut } from './Redux/sessionSlice';
import { AuthService } from './Services/AuthService';
import { configureHttp } from './Services/httpService';
import { installNativeBackButton } from './Utils/nativeBackButton';
import { installNativeStatusBar } from './Utils/nativeStatusBar';
import './index.css';

/**
 * The token provider is installed before anything renders, so no request can
 * ever go out unauthenticated by accident. It is a function rather than a
 * stored string: Firebase refreshes the token behind it, and asking each time
 * means an expired one never leaves the browser.
 */
configureHttp({
  getToken: () => AuthService.getIdToken(),
  onUnauthenticated: () => store.dispatch(signedOut())
});

installNativeBackButton();
installNativeStatusBar();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <AppRouting />
      </BrowserRouter>
    </Provider>
  </StrictMode>
);
